import React, { Fragment } from 'react';
import { RouterProvider } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { DEFAULT_TOAST_OPTIONS } from '@cokitchen/cokitchen-components';
import { ToastContainer } from 'react-toastify';
import ROOT_ROUTES from './router';
import 'react-datepicker/dist/react-datepicker.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Fragment>
    <ToastContainer {...DEFAULT_TOAST_OPTIONS} />
    <RouterProvider router={ROOT_ROUTES} />
  </Fragment>
);
reportWebVitals();
